import Component from '../core/Component'

export const EMITS = {
    POSITION_FETCHED: 'positionfetched'
}

export default class GpsRetriever extends Component {
    constructor(element, options = {}) {
        super(element, options)
    }

    prepare() {
        if (navigator.geolocation) {
            this.element.classList.remove('hidden')
            this.element.addEventListener('click', this.handleClick)

            navigator.permissions?.query({ name: 'geolocation' }).then(permission => {
                if (permission?.state === 'granted') {
                    this.element.classList.add('is-granted')
                }
            })
        }
    }

    handleClick = () => {
        const showPosition = (position) => {
            if (!position) {
                return
            }

            this.element.classList.add('is-granted')
            this.emit(EMITS.POSITION_FETCHED, {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            })
        }

        navigator.geolocation.getCurrentPosition(showPosition)
    }
}